import { RefObject, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToast } from "@chakra-ui/react";
import { FormHandles } from "@unform/core";

import { Service, useCondominiumServiceRepository } from "hooks/useCondominiumServiceRepository";

import { makeMessageError } from "utils/axiosUtils";

import { ServiceForm, ServiceFormDataProps } from ".";
import { initialServiceState } from "../constants";

export const ServiceFormCreate = () => {
  const navigate = useNavigate();
  const { id: condominiumId } = useParams();
  const toast = useToast();
  const [isMaintenance, setIsMaintenance] = useState<0 | 1>(0);
  const isMaintenanceState = {
    isMaintenance,
    setIsMaintenance
  };
  const [dataForm, setDataForm] = useState<ServiceFormDataProps>(initialServiceState);
  const dataFormState = {
    dataForm,
    setDataForm
  };
  const { postCondominiumService } = useCondominiumServiceRepository();

  const formRef: RefObject<FormHandles> = useRef(null);

  const storeService = (data: Service) => {
    postCondominiumService(data)
      .then((_r) => {
        toast({
          title: `Serviço ${data.name} salvo com sucesso.`,
          status: "success",
        });
        navigate(
          `/dashboard/condominiums/condominium/${condominiumId}/services`
        );
      })
      .catch((err) => {
        toast({ title: `${makeMessageError(err)}`, status: "error" });
      });
  };

  return (
    <ServiceForm
      formRef={formRef}
      storeService={storeService}
      isMaintenanceState={isMaintenanceState}
      dataFormState={dataFormState}
    />
  );
};
